var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3C7.55228 3 8 3.44772 8 4V17.5858L10.2929 15.2929C10.6834 14.9024 11.3166 14.9024 11.7071 15.2929C12.0976 15.6834 12.0976 16.3166 11.7071 16.7071L7.70711 20.7071C7.31658 21.0976 6.68342 21.0976 6.29289 20.7071L2.29289 16.7071C1.90237 16.3166 1.90237 15.6834 2.29289 15.2929C2.68342 14.9024 3.31658 14.9024 3.70711 15.2929L6 17.5858V4C6 3.44772 6.44772 3 7 3ZM16.2929 3.29289C16.6834 2.90237 17.3166 2.90237 17.7071 3.29289L21.7071 7.29289C22.0976 7.68342 22.0976 8.31658 21.7071 8.70711C21.3166 9.09763 20.6834 9.09763 20.2929 8.70711L18 6.41421V20C18 20.5523 17.5523 21 17 21C16.4477 21 16 20.5523 16 20V6.41421L13.7071 8.70711C13.3166 9.09763 12.6834 9.09763 12.2929 8.70711C11.9024 8.31658 11.9024 7.68342 12.2929 7.29289L16.2929 3.29289Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownArrowUp);
export default __webpack_public_path__ + "static/media/arrow-down-arrow-up.6c48f659e10dc8319aec9aa8edef2e8a.svg";
export { ForwardRef as ReactComponent };